<template>
    <form @submit.prevent="submit" v-if="!success">
        <div class="form-group">
            <label for="name">Name</label>
            <input type="text" id="name" class="form-control" v-model="name" :disabled="loading" required />
        </div>
        <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" class="form-control" v-model="email" :disabled="loading" required />
        </div>
        <div class="form-group">
            <label for="message">Message</label>
            <textarea id="message" class="form-control" rows="4" v-model="message" :disabled="loading" required></textarea>
        </div>
        <div class="row">
            <div class="col-12 text-center">
                <button type="submit" class="btn btn-link" :disabled="loading">
                    <span v-if="!loading">
                        Send Message <i class="far fa-paper-plane"></i>
                    </span>
                    <span v-else>
                        Sending
                    </span>
                </button>
            </div>
        </div>
    </form>
    <div class="alert alert-primary" v-else>
        Your message has been sent! Thank you for your interest!
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "ContactForm",
        data() {
            return {
                name: '',
                email: '',
                message: '',
                loading: false,
                success: false,
            }
        },
        methods: {
            submit() {
                this.loading = true;

                axios.post('/php/contact-form.php', {
                    fullName: this.name,
                    email: this.email,
                    mailMessage: this.message,
                }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(response => {
                    if (response.data.errors && response.data.errors.length > 0) {
                        alert(response.data.errors)
                    } else {
                        this.success = true;
                    }
                }).catch(error => {
                    console.error(error);
                })
            }
        }
    }
</script>

<style scoped>

</style>